import { genericCoworkerCompanionAPICall } from "../../connexionApi/connexionApi";
import { CategoryResponse, CategoriesResponse } from "./CategoriesTypes"
const ENDPOINT_SPACES = "categories";

const getCategories =  (token: string) => {
  const categoriesResult = genericCoworkerCompanionAPICall(
    token,
    "GET",
    ENDPOINT_SPACES as string,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as CategoriesResponse)
  return categoriesResult;
};

const getCategoryById = (token: string, idCategory: number) => {
  const endpoint = `${ENDPOINT_SPACES}/${idCategory}`;

  const categoriesResult = genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as CategoryResponse);
  return categoriesResult;
};

export { getCategories, getCategoryById };
